export default __webpack_public_path__ + "static/media/orange-labs-logo.53d9ec69.svg";